// Mapping matriciel du sous-tableau RME pour les mouvements "fin_reelle".
// Source unique du nommage des 9 champs API et de leur affichage.

export const rmeRows = [
  {
    id: "km_sup",
    title: "KM Sup. HT",
    baseField: "montant_km_supp",
  },
  {
    id: "indemnites",
    title: "Indemnités HT",
    baseField: "indemnites",
  },
  {
    id: "frais_rme",
    title: "Frais RME HT",
    baseField: "frais_remise_en_etat",
  },
];

export const rmeCols = [
  { id: "devis", title: "Prix devis", editable: true },
  { id: "definitif", title: "Prix définitif", editable: true },
  { id: "facture", title: "Prix facturé", editable: false },
];

export const getRmeField = (rowId, colId) => {
  const row = rmeRows.find((r) => r.id === rowId);
  if (!row) return null;
  return `${row.baseField}_${colId}`;
};

const currencyFormatter = (value) => `${Number(value).toFixed(2)} €`;

// Configs consommées par EditButton/EditPopover pour les 9 champs RME.
// Identique à fieldConfigs mais isolé pour ne pas polluer le tableau parent.
export const rmeFieldConfigs = rmeRows.reduce((acc, row) => {
  rmeCols.forEach((col) => {
    const field = `${row.baseField}_${col.id}`;
    acc[field] = {
      label: `${row.title} (${col.title.toLowerCase()})`,
      title: `${row.title} ${col.title}`,
      type: "number",
      props: { min: 0, step: 0.01 },
      formatter: currencyFormatter,
    };
  });
  return acc;
}, {});
